import { DocumentationCapability } from '@/components/modules/Documentation/types/DocumentationCapability';
import { DocumentationMode } from '@/components/modules/Documentation/types/DocumentationMode';

export const documentationEditModeMapper = (mode: DocumentationMode) => {
  switch (mode) {
    case DocumentationMode.VIEW_ONLY:
      return [DocumentationCapability.VIEW];
    case DocumentationMode.DOWNLOAD_ONLY:
      return [DocumentationCapability.VIEW, DocumentationCapability.DOWNLOAD];
    case DocumentationMode.UPLOAD_ONLY:
      return [DocumentationCapability.VIEW, DocumentationCapability.UPLOAD];
    case DocumentationMode.FULL:
      return [
        DocumentationCapability.VIEW,
        DocumentationCapability.DOWNLOAD,
        DocumentationCapability.UPLOAD,
        DocumentationCapability.EDIT_DOCUMENT_STATUS,
        DocumentationCapability.EDIT_REQUIRED_DOCUMENTS,
        DocumentationCapability.LENDER_SYNC,
        DocumentationCapability.LENDER_SEND,
      ];
  }
};
